import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import { appUrl } from "../../../../utils/config";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";

import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "60%",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  bodyCell: {
    padding: "10px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  // textField: {
  //   "& input": {
  //     padding: "6px 8px",
  //   },
  // },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton:{
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  modalityBoxWrapper: {
    display: "flex",
    alignItems: "flex-start",
  },
  containerBox: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: 4,
    padding: "4px 8px",
    backgroundColor: "#fff",
    maxWidth: 250,
  },
  textField: {
    flexGrow: 1,
    "& .MuiInputBase-input": {
      padding: "6px 8px",
      height: "25px",
    },
  },

  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  iconBtn: {
    padding: 4,
  },

  iconButton: {
    padding: 6,
  },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "0.5px",
  },
  // footer: {
  //   display: "flex",
  //   justifyContent: "flex-end",
  //   width: "100%",
  //   marginTop: theme.spacing(4),
  // },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    //  marginTop: 20,
    marginTop: theme.spacing(4),
  },
  // saveButton: {
  //   backgroundColor: "#f26522",
  //   color: "#fff",
  //   borderRadius: "20px",
  //   padding: "8px 24px",
  //   textTransform: "none",
  //   "&:hover": {
  //     backgroundColor: "#d4551a",
  //   },
  // },
}));

const ProductModalityTab = (props) => {
   const { addSponsorList, rowData,updateNetworkData,rowNetwork } = props;
  const { sponsorHandleBack } = props;
  const classes = useStyles();
  const [modalities, setModalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAddRow, setShowAddRow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [toggles, setToggles] = useState([false, false, false]);
  const [savingStates, setSavingStates] = useState({}); // Track saving state per index
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      // Open backdrop logic would go here
    } else if (action.type === "DESTROY_BACKDROP") {
      // Close backdrop logic would go here
    }
  };

  const handleToggleModality = (id) => {
    const updatedModalities = modalities.map((modality) =>
      modality.id === id
        ? { ...modality, selected: !modality.selected, isUpdated: true }
        : modality
    );
    setModalities(updatedModalities);
    setIsUpdated(true);
  };

  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  const network = addSponsorList?.data?.network || rowNetwork;
  const networkUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  const fetchProductModalities = async () => {
    setLoading(true);
    setError(null);

    dispatch({
      type: OPEN_BACKDROP,
    });

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantDrugTypes/false`;

      const response = await axios.get(url);

      const drugTypeList = response.data?.data?.drugTypeList || [];

      const formatted = drugTypeList.map((item, index) => ({
        ...item,
        id: item.drugTypeID || `ID-${index + 1}`,
        name: item.drugTypeName || "",
        selected: !!item.activated,
        isNew: false,
      }));

      setModalities(formatted);
    } catch (error) {
      setError("Something went wrong. Please try again.");
    } finally {
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if(network && networkUrl){
      fetchProductModalities(setModalities, setLoading);
    }
  }, [network, networkUrl]);

  const handleNextClick = async () => {
    const toggledModalities = modalities.filter(
      (modality) => modality.isUpdated
    );
    if (!toggledModalities.length) {
      props.handleNext();
      return;
    }

    if (modalities.every((modality) => !modality.selected)) {
      setErrorMessage("Please enable at least one in toggle mode.");
      return;
    }

    setErrorMessage("");

    if (isUpdated) {
      setIsSaving(true); // Start loading
      try {
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateDrugTypes`;

        const payload = {
          ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
          sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
          drugTypeList: toggledModalities.map(({ id, selected }) => ({
            drugTypeID: id,
            activated: selected,
            markForDelete: false,
          })),
        };

        await axios.post(url, payload);
        fetchProductModalities();
        props.handleNext();
      } catch (error) {
        setErrorMessage("Failed to update modalities. Please try again.");
        return;
      } finally {
        setIsSaving(false); // Stop loading
      }
    }
  };

  const deleteProductModalities = async (modality) => {
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateDrugTypes`;

      const payload = {
       ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
       sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        drugTypeList: [
          {
            drugTypeID: modality.drugTypeID,
            activated: modality.activated,
            markForDelete: true,
          },
        ],
      };
      if (modality.isNew !== true) {
        const response = await axios.post(url, payload);
        if(response.data?.status === true){
          fetchProductModalities();
          props.setProductModalities((prev) => !prev);
        }
      } else {
        const updated = modalities.filter((item) => item.id !== modality.id);
        setModalities(updated);
      }
    } catch (error) {
      console.error("Error saving modalities:", error);
      return false;
    }
  };

  
  const saveNewModality = async (modality) => {
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addPlantDrugTypes`;

      const payload = {
       ecosystemId:addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
      sponsorId: addSponsorList?.data?.organizationId || rowData?.organizationId,
        drugTypeList: [
          {
            drugTypeName: modality.name,
            drugType: "New", // Assuming drugType is same as name for new
            activated: modality.selected,
          },
        ],
      };

      const response = await axios.post(url, payload);
      if(response.data?.status === true){
        fetchProductModalities();
        props.setProductModalities((prev) => !prev);
      }

      return response.data?.data?.status === true;
    } catch (error) {
      return false;
    }
  };

  const handleToggle = (index) => {
    const updated = [...modalities];
    updated[index].selected = !updated[index].selected;
    //updated[index].isChanged = true;
    setModalities(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...modalities];
    updated[index].name = value;
    setModalities(updated);
  };

  const handleAddModality = () => {
    //const nextId = (modalities.length + 1).toString().padStart(2, "0");
    setModalities([
      ...modalities,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true, // Ensure isNew is set to true
        type: "New", // Set type to "New"
        supplyType: "custom", // Ensure supplyType is set
      },
    ]);
    setShowAddRow(true);
  };

  const handleSaveNew = async (index) => {
    const modality = modalities[index];
    if(!modality.name || !modality.name.trim()) return;
    setSavingStates(prev => ({ ...prev, [index]: true }));

    const success = await saveNewModality(modality);

    if (success) {
      // Refresh full list from API after successful save
      await fetchProductModalities();
    } else {
      // alert("Failed to save new modality.");
    }
     setSavingStates(prev => ({ ...prev, [index]: false }));
  };

  const handleCancel = (index) => {
    const updated = modalities.filter((_, i) => i !== index);
    setModalities(updated);
  };

  return (
    <div>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell className={classes.headerCell}>
              Product Modality
            </TableCell>
            <TableCell className={classes.headerCell}>
              Product Modality ID
            </TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px",
                    border: "2px solid #FF0000",
                    backgroundColor: "#FFF0F0",
                    width: "100%",
                  }}
                >
                  <Typography style={{ textAlign: "center" }}>
                    {error}
                  </Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            modalities.map((modality, index) => (
              <TableRow key={modality.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={modality.selected}
                    // onChange={() => handleToggle(index)}
                    onChange={() => handleToggleModality(modality.id)}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {modality.isNew && showAddRow ? (
                    // <div style={{ display: "flex", alignItems: "flex-start" }}>
                    //   <TextField
                    //     placeholder="Type Text Here"
                    //     variant="outlined"
                    //     value={modality.name}
                    //     onChange={(e) =>
                    //       handleNameChange(index, e.target.value)
                    //     }
                    //     className={classes.textField}
                    //   />
                    //   <div className={classes.inlineActions}>
                    //     <IconButton
                    //       onClick={() => handleSaveNew(index)}
                    //       className={classes.iconBtn}
                    //     >
                    //       <SaveIcon fontSize="small" />
                    //     </IconButton>
                    //     <IconButton
                    //       onClick={() => handleCancel(index)}
                    //       className={classes.iconBtn}
                    //     >
                    //       <CancelIcon fontSize="small" />
                    //     </IconButton>
                    //   </div>
                    // </div>
                    <div className={classes.modalityBoxWrapper}>
                      <div className={classes.containerBox}>
                        <TextField
                          placeholder="Type Text Here"
                          variant="standard"
                          value={modality.name}
                          onChange={(e) =>
                            handleNameChange(index, e.target.value)
                          }
                          onBlur={(e) => {
                            const trimmed = e.target.value.trim();
                            if (trimmed !== e.target.value) {
                              handleNameChange(index, trimmed);
                            }
                          }}
                          className={classes.textField}
                          InputProps={{
                            disableUnderline: true, // removes default underline
                            onBeforeInput: (e) => {
                              const allowedChars = /^[a-zA-Z\s\-&()]+$/;
                              if (!allowedChars.test(e.data)) {
                                e.preventDefault();
                              }
                                }
                          }}
                        />
                      </div>
                      <div className={classes.inlineActions}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => handleSaveNew(index)}
                          className={classes.iconBtn}
                          disabled={!modality.name.trim() || modalities.some((m, i) => 
                                i !== index && m.name?.trim().toLowerCase() === modality.name.trim().toLowerCase()) || savingStates[index] }
                        >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    modality.name
                  )}
                </TableCell>

                <TableCell className={classes.bodyCell}>
                  {modality.id}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {modality.isNew === true ||
                  modality.drugType !== "Default" ? (
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteProductModalities(modality)}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}
      <Button
        variant="outlined"
        onClick={handleAddModality}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Product Modality
      </Button>

      <div className={classes.footer}>

              <Grid
                  className={classes.backButton}
                onClick={sponsorHandleBack}
                     >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{
            opacity: isSaving ? 0.7 : 1,
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
                          <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ProductModalityTab;
